import PropTypes from 'prop-types';
import { Row, Col } from "reactstrap";
import { useEffect, useState } from "react";
import { toast } from "../../../../core/helpers/message-helper";
import FormModal from "../../../../core/ui/components/FormModal";
import {
    crearOEditarVersionContrato,
    selectTipoContrato,
    selectTipoVersiones,
} from "../../services/versiones-contratos-service";
import InputController from "../../../../core/ui/components/InputController";
import SelectController from "../../../../core/ui/components/SelectController";
import { useForm } from "react-hook-form";

const FormVersionesContratos = ({ modalState, onSave }) => {
    const { versionContrato } = modalState.data;
    const [tiposContratos, setTiposContratos] = useState([]);
    const [tiposVersiones, setTiposVersiones] = useState([]);

    const defaultValues = {
        id: versionContrato.id || "",
        detalle: versionContrato.detalle || "",
        html: versionContrato.html || "",
        parametro_tipo_contrato_id: versionContrato.nombre_tipo_contrato_id
            ? {
                  label: versionContrato.nombre_tipo_contrato_id,
                  value: versionContrato.parametro_tipo_contrato_id,
              }
            : "",
        parametro_tipo_version_id: versionContrato.nombre_tipo_version_id
            ? {
                  label: versionContrato.nombre_tipo_version_id,
                  value: versionContrato.parametro_tipo_version_id,
              }
            : "",
    };

    const form = useForm({ defaultValues });
    useEffect(() => form.reset(defaultValues), [versionContrato]);

    const onCreateVersionContrato = async (versionContrato) => {
        versionContrato.parametro_tipo_contrato_id =
            versionContrato.parametro_tipo_contrato_id.value;
        versionContrato.parametro_tipo_version_id =
            versionContrato.parametro_tipo_version_id.value;
        const resp = await crearOEditarVersionContrato(versionContrato);
        if (!resp.status) return toast.error(resp.message);

        toast.success(resp.message);
        modalState.close();
        onSave();
    };

    useEffect(async () => {
        const resp = await selectTipoContrato();
        if (!resp.status) return toast.error(resp.message);

        const tiposContratos = resp.data.map((tipoContrato) => {
            return {
                value: tipoContrato.id,
                label: tipoContrato.nombre,
            };
        });

        setTiposContratos(tiposContratos);
    }, []);

    useEffect(async () => {
        const resp = await selectTipoVersiones();
        if (!resp.status) return toast.error(resp.message);

        const tiposVersiones = resp.data.map((tipoVersion) => {
            return {
                value: tipoVersion.id,
                label: tipoVersion.nombre,
            };
        });

        setTiposVersiones(tiposVersiones);
    }, []);

    return (
        <FormModal
            size="lg"
            form={form}
            id="formVersionesContratos"
            onSubmit={onCreateVersionContrato}
            isOpen={modalState.show}
            headerTitle={modalState.title}
            closeModal={() => modalState.set({ show: false })}
        >
            <Row>
                <InputController
                    name="id"
                    type="hidden"
                    errors={form.formState.errors}
                    control={form.control}
                />
                <Col sm={12}>
                    <InputController
                        type="textarea"
                        name="detalle"
                        label="Detalle"
                        errors={form.formState.errors}
                        control={form.control}
                        placeholder="Detalle"
                        rules={{ required: "Este campo es requerido" }}
                    />
                </Col>
                <Col sm={12}>
                    <InputController
                        type="textarea"
                        name="html"
                        label="Html"
                        errors={form.formState.errors}
                        control={form.control}
                        placeholder="Html"
                        rules={{ required: "Este campo es requerido" }}
                    />
                </Col>
                <Col sm={6}>
                    <SelectController
                        options={tiposContratos}
                        label="Tipo Contrato"
                        errors={form.formState.errors}
                        control={form.control}
                        name="parametro_tipo_contrato_id"
                        rules={{ required: "Este campo es requerido" }}
                        placeholder="Tipo Contrato"
                    />
                </Col>
                <Col sm={6}>
                    <SelectController
                        options={tiposVersiones}
                        label="Tipo Versión"
                        errors={form.formState.errors}
                        control={form.control}
                        name="parametro_tipo_version_id"
                        rules={{ required: "Este campo es requerido" }}
                        placeholder="Tipo Versión"
                    />
                </Col>
            </Row>
        </FormModal>
    );
};

FormVersionesContratos.propTypes = {
    modalState: PropTypes.object,
    onSave: PropTypes.func
}

export default FormVersionesContratos;
